'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _baseUtils = require('../utils/baseUtils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minDate = -8640000000000000;

var VersionManager = function () {
  function VersionManager() {
    var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dateCreated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : minDate;
    var manualUpdates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck3.default)(this, VersionManager);

    this.features = features;
    this.update(dateCreated, manualUpdates);
  }

  (0, _createClass3.default)(VersionManager, [{
    key: 'update',
    value: function update(dateCreated) {
      var manualUpdates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.dateCreated = dateCreated || this.dateCreated;
      this.manualUpdates = manualUpdates;
    }
  }, {
    key: 'getFeature',
    value: function getFeature(featureName) {
      var featureVersions = this.features[featureName];
      if (!featureVersions) {
        return;
      }

      var manualUpdate = this.manualUpdates[featureName];
      var manualUpdateDateStr = _lodash2.default.get(manualUpdate, 'date') || manualUpdate;
      var manualUpdateDate = manualUpdateDateStr ? _baseUtils.baseUtils.getDateCreatedTicksFromStr(manualUpdateDateStr) : null;

      for (var i = featureVersions.length - 1; i >= 0; i--) {
        var versionDate = manualUpdateDate || this.dateCreated;
        if (versionDate >= featureVersions[i].dateFrom) {
          return featureVersions[i];
        }
      }
    }
  }, {
    key: 'getVersion',
    value: function getVersion(featureName) {
      var feature = this.getFeature(featureName);
      return feature ? feature.version : VersionManager.Versions.min;
    }
  }, {
    key: 'getFeaturesWithNewerVersions',
    value: function getFeaturesWithNewerVersions() {
      var _this = this;

      var manualUpdates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var featuresWithNewerVersions = {};
      var isStore = _baseUtils.baseUtils.isStoreGallery();
      (0, _keys2.default)(this.features).forEach(function (featureName) {
        var featureLatest = _lodash2.default.last(_this.features[featureName]);
        var featureManualUpdate = manualUpdates[featureName];
        var featureManualUpdateDate = featureManualUpdate ? _baseUtils.baseUtils.getDateCreatedTicksFromStr(_lodash2.default.get(featureManualUpdate, 'date') || featureManualUpdate) : null;
        var isAFutureFeature = featureLatest.dateFrom > Date.parse(new Date());
        var shouldAffectProGallry = typeof featureLatest.affectsProGallery === 'undefined' || featureLatest.affectsProGallery && !isStore;
        var shouldAffectArtStore = typeof featureLatest.affectsArtStore === 'undefined' || featureLatest.affectsArtStore && isStore;
        var shouldAffect = isStore ? shouldAffectArtStore : shouldAffectProGallry;
        var featureHasNewerVersion = featureLatest.dateFrom > (featureManualUpdateDate || _this.dateCreated);
        var featureNeedsToUpgrade = !isAFutureFeature && featureHasNewerVersion && shouldAffect;
        if (featureNeedsToUpgrade && !featureLatest.ignoreUserManuaUpdate) {
          featuresWithNewerVersions[featureName] = featureLatest;
        }
      });
      return featuresWithNewerVersions;
    }
  }]);
  return VersionManager;
}();

VersionManager.Versions = {
  min: 'min'
};

module.exports = VersionManager;